/** components */
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Field } from 'react-final-form';
import { useNavigate, useLocation } from 'react-router-dom';

import TenantConfig from '../../config';

/** components */
import { PhoneCodeInput } from '../FormElements';

const PhoneVerificationForm = ({
  handleSubmit,
  submitting,
  pristine,
  submitError,
  formOptions,
  values,
  form,
  mutators,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeFocus, setActiveFocus] = useState('code0');
  const query = useMemo(() => new URLSearchParams(location.search), [location]);
  const destination = query.get('app');

  // copy code from clipboard
  useEffect(() => {});

  const onPaste = (e) => {
    e.preventDefault();
    const clipboardText = e.clipboardData.getData('Text');

    const re = /\d{6}/;
    const isClipboardTheCode = re.test(clipboardText);

    if (!isClipboardTheCode) {
      return;
    }

    for (let i = 0; i < 6; i++) {
      form.mutators.setValue(`code${i}`, clipboardText[i]);
    }

    setActiveFocus('code5');
  };
  const handlePreviousClick = (e) => {
    if (destination) {
      window.location = `/auth/sign-in?app=${destination}`;
    } else if (location.pathname.startsWith('/profile')) {
      window.location.reload();
    } else {
      navigate(-1);
    }
  };

  const code = useMemo(() => {
    let res = '';
    for (let i = 0; i < 6; i++) {
      res += values[`code${i}`];
    }
    return res;
  }, [values]);

  useEffect(() => {
    if (code.length === 6) {
      form.change('code', code);
    }
  }, [code, form]);

  const onInput = useCallback(
    (e) => {
      const data = e.data || e.target.value;
      if (!data) return;
      if (data.length === 1) return;
      e.preventDefault();

      const re = /\d{6}/;
      const isClipboardTheCode = re.test(data);

      if (!isClipboardTheCode) {
        return;
      }

      for (let i = 0; i < 6; i++) {
        form.mutators.setValue(`code${i}`, data[i]);
      }
    },
    [form.mutators]
  );

  return (
    <form onSubmit={handleSubmit} className="form">
      <div className="input-flex">
        {formOptions.fields.map((f, index) => {
          return (
            <PhoneCodeInput
              {...f}
              onPaste={onPaste}
              onInput={onInput}
              focus={activeFocus}
              key={`phone_form_${f.name}`}
              setActiveFocus={setActiveFocus}
              index={Number(index)}
              form={form}
              values={values}
            />
          );
        })}
        <Field name="code">
          {({ input }) => (
            <input
              {...input}
              autoFocus
              pattern="[0-9]*"
              hidden
              type="number"
              inputMode="numeric"
              autoComplete="one-time-code"
              style={{ display: 'none' }}
            />
          )}
        </Field>
      </div>
      {submitError && submitError?.name === 'Pofile_Err' && (
        <p className="error-text">{submitError.message}</p>
      )}
      <button
        className="btn primary-btn"
        type="submit"
        disabled={submitting || pristine || code.length < 6}
      >
        Confirm
      </button>
      {TenantConfig?.auth.renderReturnBtn && (
        <button type="button" className="btn outline-btn" onClick={() => handlePreviousClick()}>
          {destination ? 'Return to Sign In' : 'Return'}
        </button>
      )}
      {submitError && submitError?.name !== 'Pofile_Err' && (
        <p className="error-text">{submitError}</p>
      )}
    </form>
  );
};

export default PhoneVerificationForm;
